import { render, staticRenderFns } from "./followTop.vue?vue&type=template&id=115ab088&scoped=true&"
import script from "./followTop.vue?vue&type=script&lang=js&"
export * from "./followTop.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/followTop.css?vue&type=style&index=0&id=115ab088&lang=css&scoped=true&"
import style1 from "./followTop.vue?vue&type=style&index=1&id=115ab088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115ab088",
  null
  
)

export default component.exports